import React from 'react'
import Layout from '../components/layout/Layout'
import RewardTracker from '../components/rewards/RewardTracker'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'
import Button from '../components/ui/Button'

const { FiArrowLeft } = FiIcons

const RewardTrackingPage = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header with Back Button */}
        <div className="flex items-center gap-4 mb-8">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => window.history.back()}
            className="flex items-center gap-2"
          >
            <SafeIcon icon={FiArrowLeft} />
            Back
          </Button>
          
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
              Reward Tracking
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Monitor reward redemptions and analyze family motivation patterns
            </p>
          </div>
        </div>

        {/* Main Content */}
        <RewardTracker />
      </div>
    </Layout>
  )
}

export default RewardTrackingPage